import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceManagement-androidManagedStoreAppConfigurationSchemas'

export const intuneAndroidAppConfigurationSchemasApi = createApi({
  reducerPath: 'intuneAndroidAppConfigurationSchemas',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getAndroidAppConfigurationSchema: builder.query({
      query: ({ customerId, packageId }) => ({
        url: `${url}/${encodeURIComponent(packageId)}`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetAndroidAppConfigurationSchemaQuery } = intuneAndroidAppConfigurationSchemasApi

export const useGetAndroidAppConfigurationSchema = ({ packageId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetAndroidAppConfigurationSchemaQuery(
    { customerId, packageId },
    {
      skip: !packageId || !customerId,
      ...options,
    },
  )
}
